module.exports = __webpack_public_path__ + "static/flags/DA-7d35789d5374b04e83426c214a37b3c9.gif";